import { ChangeDetectionStrategy, Component, ElementRef, ViewChild } from '@angular/core';
import { ICellRendererAngularComp } from 'ag-grid-angular';
import { ICellRendererParams } from 'ag-grid-community';

export interface GridImageTextCellConfig {
  showImage?: boolean;
}

@Component({
  selector: 'app-image-text-cell',
  standalone: true,
  imports: [],
  templateUrl: './image-text-cell.component.html',
  styleUrl: './image-text-cell.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class ImageTextCellComponent implements ICellRendererAngularComp {

  showImage = true;
  name: string = '';
  imageUrl: string = '';
  color: string = '';

  isMobile = false;

  @ViewChild('wrapper', { static: true }) private wrapper!: ElementRef;

  agInit(params: ICellRendererParams & GridImageTextCellConfig): void {
    this.isMobile = params.context?.isMobile || false;

    this.showImage = params.showImage !== undefined ? params.showImage : true;
    this.name = params.value;
    
    if (params.data) {
      this.imageUrl = params.data.thumbnail || '';
      this.color = params.data.color || '';
    }

    // Aggiorna il tooltip
    if (this.wrapper) {
      const el = this.wrapper.nativeElement;
      params.setTooltip(`${params.value}`, () => el.scrollWidth > el.clientWidth);
    }
  }

  refresh(params: ICellRendererParams): boolean {
    this.agInit(params);
    return true;
  }
}
